import { takeEvery, put, call, debounce } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import {
getUserInfoSuccess,
getUserInfoError,
updateUserInfoSuccess,
updateUserInfoError,
getPhoneEmailExistsSuccess,
getPhoneEmailExistsError,
updateLanguageError, updateLanguageSuccess, changePasswordSuccess, changePasswordError, updateTimezoneSuccess,
updateTimezoneError
} from "../features/user.slice";
import { baseInstance } from "../../service/instance";
import { ENDPOINTS } from "../../service/api";
import { toastError, toastSuccess } from "../../shared/util/toast.message";
import { MESSAGES } from "../../config/app";


function* getUserSaga(action: any) {
 // const { callBackSuccess,successMessage } = action?.payload;
  try {
    const res: AxiosResponse = yield call(
      baseInstance.get,
      ENDPOINTS?.USER_INFO,
    );
    if (res?.data?.statuscode === 200) {
      let ress: any = res.data.data.user;
      yield put(getUserInfoSuccess(ress));
    }
  } catch (err:any) {
    toastError(err.message);
    yield put(getUserInfoError(err));
  }
}

function* updateUserSaga(action: any) {
    const { callBackSuccess, user, successMessage, callBackFailure } = action?.payload;
    try {
      let res: AxiosResponse = yield call(
        baseInstance.patch,
        ENDPOINTS?.UPDATE_USER,
        user
      );
      if (res.data.statuscode === 200) {
        let ress: any = res.data.data;
        yield put(updateUserInfoSuccess(ress));
        toastSuccess(successMessage?successMessage:'Change successful');
        callBackSuccess();
      }
    } catch (err:any) {
      toastError(err.message);
      callBackFailure && callBackFailure();
      yield put(updateUserInfoError(err));
    }
  }

function* changePasswordSaga(action: any) {
  const { callBackSuccess, callBackFailure, password, successMessage } = action?.payload;
  try {
    let res: AxiosResponse = yield call(
      baseInstance.post,
      ENDPOINTS?.RESET_PASSWORD,
      password
    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(changePasswordSuccess(ress));
      toastSuccess(successMessage ? successMessage : "Password change successful");
      callBackSuccess();

    }
  } catch (err: any) {
    toastError(err.message);
    callBackFailure();
    yield put(changePasswordError(err));
  }
}

function* updateLanguageSaga(action: any) {
  const { callBackSuccess, language } = action?.payload;
  try {
    let res: AxiosResponse = yield call(
      baseInstance.patch,
      ENDPOINTS?.UPDATE_LANGUAGE,
      language
    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(updateLanguageSuccess(ress));
      toastSuccess(MESSAGES.updateLanguageSuccess);
      callBackSuccess();
    }
  } catch (err: any) {
    toastError(err.message);
    yield put(updateLanguageError(err));
  }
}

function* updateTimezoneSaga(action: any) {
  const { callBackSuccess, timezone } = action?.payload;
  try {
    let res: AxiosResponse = yield call(
      baseInstance.patch,
      ENDPOINTS?.UPDATE_TIMEZONE,
      timezone
    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(updateTimezoneSuccess(ress));
      toastSuccess(MESSAGES.updateTimezoneSuccess);
      callBackSuccess();
    }
  } catch (err: any) {
    toastError(err.message);
    yield put(updateTimezoneError(err));
  }
}

function* checkPhoneEmailExistence(action: any) {
  const { callBackSuccess, params, callBackFailure } = action?.payload;
  try {
    let res: AxiosResponse = yield call(
      baseInstance.get,
      ENDPOINTS?.PHONEOREMAIL_EXIST,
      {params}
    );
    if (res.data.statuscode === 200) {
      let ress: any = res.data.data;
      yield put(getPhoneEmailExistsSuccess(ress));
      callBackSuccess();
    }
  } catch (err: any) {
    callBackFailure();
    toastError(err.message);
    yield put(getPhoneEmailExistsError(err));
  }
}

  function* userSaga() {
    yield takeEvery("userStateSlice/getUserInfo", getUserSaga);
    yield takeEvery("userStateSlice/updateUserInfo", updateUserSaga);
    yield takeEvery("userStateSlice/changePassword", changePasswordSaga);
    yield takeEvery("userStateSlice/updateLanguage", updateLanguageSaga);
    yield takeEvery("userStateSlice/updateTimezone", updateTimezoneSaga);
    yield takeEvery("userStateSlice/getPhoneEmailExists", checkPhoneEmailExistence);
  }
  
  export default userSaga;